export const version = '10.77.5'
export const sha = '8f1843f3d'
